import React from 'react';
import { Box, Typography, Grid, Link } from '@mui/material';
import { useTheme } from '@mui/system';
import config from '@configFile';
import ShareButton from '@components/ShareButton';
import PosterDetails from '@components/PosterDetails';
import { getTitleFromPageDeal, getPostPrefix } from '@utils/index';
import { AdminSlugActionsBySlug } from '@components/AdminSlugActions';
import { PageDeal } from '@api/database/models/pageDeal';
import ButtonContainer from '@pages/Blog/components/ButtonContainer';
import Title from '../Title';
import ShowPageDeals from './components/ShowPageDeals';

const PageDealFeedCard = ({
  pageDeal,
  permalink,
  isMainContent
}: {
  pageDeal: PageDeal;
  permalink: string;
  isMainContent?: boolean;
}) => {
  const title = `${getTitleFromPageDeal(pageDeal)}`;
  const theme = useTheme();

  const renderPageDealDescription = () => {
    if (!pageDeal.description) {
      return null;
    }

    return (
      <Box
        sx={{
          margin: '20px 0 0 0'
        }}
      >
        <Typography
          variant="body1"
          sx={{
            '@media (max-width: 540px)': {
              fontSize: '14px'
            }
          }}
        >
          {pageDeal.description}
        </Typography>
      </Box>
    );
  };

  const isDarkMode = theme.palette.mode === 'dark';

  const renderPageDealImage = () => {
    if (!pageDeal?.collageImage && !pageDeal?.imageLarge) {
      return null;
    }

    const componentImage = pageDeal.collageImage || pageDeal.imageLarge;
    const width = pageDeal.collageImageWidth || pageDeal.imageLargeWidth;
    const smallImageWidth =
      pageDeal.collageImageSmallWidth || pageDeal.imageLargeWidth;
    const smallImage = pageDeal?.collageImageSmall || pageDeal.imageLarge;

    return (
      <Grid item xs={12}>
        <Box textAlign="center">
          <Link href={`/p/${pageDeal.slug}`}>
            <Box
              sx={{
                display: 'block',
                '@media (max-width: 600px)': {
                  display: 'none'
                }
              }}
            >
              <img
                src={componentImage?.replace('http:', 'https:')}
                className={pageDeal?.collageImage ? 'page-deal-lead-image' : ''}
                style={
                  !pageDeal?.collageImage
                    ? {
                        maxWidth: '100%',
                        width:
                          pageDeal?.collageImage &&
                          pageDeal?.collageImageWidth > 600
                            ? `${width}px`
                            : 'initial'
                      }
                    : {}
                }
                alt=""
              />
            </Box>
            <Box
              sx={{
                display: 'none',
                '@media (max-width: 600px)': {
                  display: 'block'
                }
              }}
            >
              <img
                src={smallImage?.replace('http:', 'https:')}
                style={{
                  maxWidth: '100%',
                  width:
                    smallImage && smallImageWidth > 600
                      ? `${width}px`
                      : 'initial'
                }}
                alt=""
              />
            </Box>
          </Link>
        </Box>
      </Grid>
    );
  };

  return (
    <Box id={`page-deal-${pageDeal.slug}`}>
      <Title
        permalink={permalink}
        isMainContent={!!isMainContent}
        link={`/p/${pageDeal.slug}`}
        title={`${getPostPrefix()}${title}`}
      />
      <Typography variant="caption" component="div">
        <Box
          sx={{
            // backgroundColor: '#e7e7e7',
            // margin: '0px -17px',
            // padding: '10px 17px',
            backgroundColor: theme.palette.secondaryBackground,
            margin: '0px -16px',
            padding: '10px 17px',
            border: isDarkMode ? `1px solid transparent` : `1px solid #bdc6ca`
          }}
        >
          <PosterDetails postDate={new Date(pageDeal.postDate).toISOString()} />
        </Box>
      </Typography>
      <Grid
        container
        sx={{
          padding: '1rem 0 0 0',
          position: 'relative'
        }}
      >
        <ButtonContainer>
          <ShareButton
            title={title}
            url={`${config.SITE_URL}/p/${pageDeal.slug}`}
          />
          <AdminSlugActionsBySlug slug={pageDeal?.slug} />
        </ButtonContainer>
        {renderPageDealImage()}
        {renderPageDealDescription()}
        <ShowPageDeals slug={pageDeal?.slug} />
      </Grid>
    </Box>
  );
};

export default PageDealFeedCard;
